// import store from './store'
// const { user, premissions } = store.state

const microApps = [
    //1C系统
    {
        name: 'vue-admin-1c',
        // 生产部署地址：整页跳转到子应用独立站点（子应用为 standalone 模式，qiankun 挂载代码已注释）
        entry: 'https://data.lskjcd.com/1c/',
        activeRule: '/1c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-admin-1c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
    //2C系统
    {
        name: 'vue-admin-2c',
        entry: 'https://data.lskjcd.com/2c/',
        activeRule: '/2c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-admin-2c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
    //隧道2C
    {
        name: 'vue-tunnel-2c',
        entry: 'https://data.lskjcd.com/tunnel/',
        activeRule: '/tunnel2c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-tunnel-2c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
    //3C系统
    {
        name: 'vue-admin-3c',
        entry: 'https://data.lskjcd.com/3c/',
        activeRule: '/3c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-admin-3c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
    //4C系统
    {
        name: 'vue-admin-4c',
        entry: 'https://data.lskjcd.com/4c/',
        activeRule: '/4c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-admin-4c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
    //5C系统
    {
        name: 'vue-admin-5c',
        entry: 'https://data.lskjcd.com/5c/',
        activeRule: '/5c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-admin-5c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
    //浮冰检测
    {
        name: 'vue-floating-ice',
        entry: 'https://data.lskjcd.com/icing/',
        activeRule: '/icing',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-floating-ice' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
    //简易4C
    {
        name: 'vue-simple-4c',
        entry: 'https://data.lskjcd.com/simple4c/',
        activeRule: '/simple4c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-simple-4c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
     //简易4C
     {
        name: 'vue-simple-1c',
        entry: 'https://data.lskjcd.com/simple1c/',
        activeRule: '/simple1c',
        container: '#subapp-viewport', // 子应用挂载的div
        props: {
            // actions,
            routerBase: '/vue-simple-1c' // 下发路由给子应用，子应用根据该值去定义qiankun环境下的路由
        }
    },
]

export default microApps

